<template>
  <div class="container" id="pcLayout">
    <headerTemp v-if="isRouterAlive"/>
    <div class="content">
      <router-view v-if="isRouterAlive"></router-view>
    </div>
    <footerTemp @scrollTop="scrollTop"/>
    <img class="coupon" :src="`${$g.imgPrefix}/img/home/Group1000005850@2x.webp`" @click="openCoupon">
    <coupon ref="coupon"/>
  </div>
</template>
<script>
import headerTemp from "../pc/headerTemp";
import footerTemp from "../pc/footerTemp";
import coupon from "@/components/coupon";
export default {
  name: "Layout",
  components: {
    headerTemp,
    footerTemp,
    coupon
  },
  provide() {
    return {
      reload: this.reload,
      reloadApp:this.reload
    }
  },
  created() {
    this.checkToken();
    // 预加载资源
    const img = new Image();
    img.src = require("../../assets/img/home/Group1000005850@2x.webp");
  },
  data() {
    return {
      selectedIndex: "home",
      selectedKeys: "home",
      name: "",
      collapsed: false,
      isRouterAlive: true,
      dialogVisible:false,
    };
  },
  watch: {
    '$route.path': function () {
      this.SelectedKeys = [this.$route.path]
    }
  },
  methods: {
    openCoupon(){
      this.$nextTick(()=>{
        this.$refs['coupon'].init();
      })
    },
    scrollTop(id) {
      const yOffset = -40;
      const element = document.getElementById(id);
      const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({top: y, behavior: 'smooth'});
    },
    tohome() {
      this.$router.push({name: "home"});
    },
    initData() {
      let info = this.$cookies.get("userInfo");
      if (info) {
        let {name} = JSON.parse(info);
        this.name = name;
      }
    },
    reload() {
      this.isRouterAlive = false
      this.$nextTick(() => (this.isRouterAlive = true))
    },
    async checkToken() {
      window.console.log("---------layout")
      //先注释
      // let now = new Date().getTime();
      // let deadline = this.$cookies.get("deadline");
      // let token = this.$cookies.get("token");
      // let userInfo = this.$cookies.get("userInfo");
      // if (!deadline || !token || !userInfo) {
      //     return this.$router.push({ name: "login" });
      // }
      // if (deadline < now) {
      //     return this.$router.push({ name: "login" });
      // }
      this.initData();
    }

  }
};
</script>
<style lang="scss" scoped>
.container{
  position: relative;
  .content {
    padding: 122px 0 107px 0;
  }
  .coupon{
    z-index: 99;
    position: fixed;
    right: 30px !important;
    bottom: 102px !important;
    width: 68px;
    cursor: pointer;
    animation: coupon 3s infinite;
  }
  @keyframes coupon {
    0% {
      transform: translateX(-10px) rotate(20deg);
    }
    50% {
      transform: translateX(10px) rotate(-20deg);
    }
    100% {
      transform: translateX(-10px) rotate(20deg);
    }
  }
}


</style>

